const URIS = {
    'login':'/jobseeker_login',
    'register':'/jobseeker_register',
    'employer_login':'/employer_login',
    'employer_register':'/employer_regitser',
    'employee' : '/me',
    'profile_image':'/update_profile_pic',
    'update_alerts':'/update_alerts',
    'states':'/states',
    'subcity':'/sublocation/',
    'courses':'/courses',
    'specifications':'/specifications/',
    'designations':'/designations',
    'jobrole':'/jobrole',
    'cities':'/city',
    'personaldetails':'/personaldetails',
    'high_qualification': '/morequalifiation',
    'languages':'/languages',
    'skills':'/skills',
    'logout': '/logout',
    'listing': '/job_listing',
    'jobDetails':'/job_listing/',
    'jobapplications':'/jobapplications',
    'applied_list':'/applied_jobs/',
    'seeker_logout':'/logout',

    'post_job':'/job/post',
    'edit_job':'/edit',
    'job_designations':'/jobdesignations',
    'jobcategories':'/jobcategories',
    'employer':'/mydashboard',
    'list_jobs':'/job/list',
    'getJob':'/job',
    'reset_password':'/reset_password',
    'view_contact' : '/view_contact',
    'sendOtp': '/sendOtp',
    'verifyOtp': '/verifyOtp',
    'employer_reset_pass' : '/change_password',
    'getCandidateCount': '/candidate-count',
    'candidate_search': '/candidate-search',
    'editProfile' : '/profile_update',
    'active_jobfairs': '/active_jobfairs',
    'applicant_profile':'/applicant-profile',
    'jobfair': '/jobfair',
    'all_jobs':'/all_jobs',
    'getQuestions':'/get-default-questions',
    'add_question':'/questionnaire',
    'questionnaire':'/list_questionnaire',
    'questionnaireResult':'/getQuestionnaireResult',
    'dealbreaker' : '/dealbreaker',
    'filter' : '/filter',
    'checkEmail':'/check_email',
    'jobpost':'/job/jobpost',
    'send_reset_link': '/send_reset_link',
    'forgot_password_reset': '/forgot_password_reset',
    'email_sms_template': '/email_sms_template',
    'send_mail':'/send_mail',
    'packages': '/packages',
    'job_responses':'/job_responses',
    'ms_auth_token': '/100ms_auth_token',
    'interview':'/interview',
    'client_packages': '/client_packages',
    'payment':'/payment',
    'job_status_update':'/job_status_update',
    'contact':'/addContact',
    'jobUrl':'/job/url',
    'assessment':'/assessment',
    'template':'/list/job_description_template'
}


export default URIS;
